import React from 'react';
import { ProgressBar } from 'shared/ProgressBar';
import { Button } from 'shared/Button/NewButton';
import { CheckmarkCircleIcon } from 'shared/Icon/components/CheckmarkCircleIcon';
import {
  UploaderContainer,
  UploaderLabelsContainer,
  UploaderStatusContainer,
  UploaderStatusHeading,
  UploaderStatusLabel,
} from '../styles';
import {
  ContentWrapper,
  IconWrapper,
  uploaderCancelButtonStyle,
} from './styles';

type UploadingStateProps = {
  percentageComplete?: number;
  onCancel: () => void;
  isProcessing?: boolean;
};

const onClickCancelButton = (
  e: React.FormEvent,
  onCancelUpload: () => void
) => {
  e.preventDefault();
  onCancelUpload();
};

export const UploadingState = ({
  percentageComplete = 100,
  onCancel,
  isProcessing,
}: UploadingStateProps) => {
  const cancelButtonLabel = isProcessing ? 'Delete' : 'Cancel';
  return (
    <ContentWrapper>
      <UploaderContainer>
        <UploaderLabelsContainer>
          <UploaderStatusHeading>
            {isProcessing
              ? 'Processing...'
              : percentageComplete === 100
              ? 'Uploaded!'
              : 'Uploading...'}
          </UploaderStatusHeading>
          <UploaderStatusLabel>
            {isProcessing
              ? 'An audio preview will be ready soon'
              : `${percentageComplete}%`}
          </UploaderStatusLabel>
        </UploaderLabelsContainer>
        <UploaderStatusContainer>
          {isProcessing || percentageComplete < 100 ? (
            <Button
              color="white"
              className={uploaderCancelButtonStyle}
              onClick={(e: React.FormEvent) => onClickCancelButton(e, onCancel)}
            >
              {cancelButtonLabel}
            </Button>
          ) : (
            <IconWrapper>
              <CheckmarkCircleIcon />
            </IconWrapper>
          )}
        </UploaderStatusContainer>
      </UploaderContainer>
      <ProgressBar percentage={percentageComplete} height={4} />
    </ContentWrapper>
  );
};
